import { lazy } from 'react';
import CityForm from './CityForm';
import CityList from './CityList';

const CityConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/cities',
            element: <CityList />,
        },
        {
            path: '/addCity',
            element: <CityForm />,
        },
        {
            path: '/editCities/:id',
            element: <CityForm />,
        },
    ],
};

export default CityConfig;
